import { get } from '../utils/api';

export default async function fetchAvailableApps(slug) {
  try {
    if (!slug) {
      console.error('No slug provided to fetchAvailableApps');
      return [];
    }

    const response = await get(`/api/v1/customers/${slug}/apps`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    // The API should now return apps with launch URLs included
    return data.apps || [];
  } catch (error) {
    console.error('Error fetching available apps:', error);
    // Fallback to empty array on error
    return [];
  }
}
